import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-tij",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-tij.component.html",
  styleUrl: "./prefix-tij.component.less",
})
export class PrefixTijComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["tij"];
  }
}
